import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import classnames from 'classnames2';
import _ from 'lodash';
import React from 'react';
import { Icon } from '../Icon';
import { LoadingSpinner } from '../LoadingSpinner';
import { SelectChild } from './Select.Child';
import { isSelectFooter } from './Select.Footer';
import styles from './Select.scss';
var designTokenUnit1 = 8; // from OG design language scss

function isEqual(a, b) {
  return a && b && a.equals ? a.equals(b) : a === b;
}

function createSelect(buttonSize) {
  var _a;

  return _a = /*#__PURE__*/function (_React$Component) {
    _inherits(_a, _React$Component);

    var _super = _createSuper(_a);

    function _a() {
      var _this;

      _classCallCheck(this, _a);

      _this = _super.apply(this, arguments);
      _this.wrapperRef = null;
      _this.state = {
        whichMenuIsOpen: null
      };

      _this.setWrapperRef = function (node) {
        _this.wrapperRef = node;
      };

      _this.handleClickOutside = function (event) {
        if (_this.wrapperRef && !_this.wrapperRef.contains(event.target)) {
          _this.hideMenu();

          event.stopPropagation();
        }
      };

      _this.toggleMenu = function () {
        _this.setState(function (prevState) {
          if (prevState.whichMenuIsOpen === null) {
            return {
              whichMenuIsOpen: []
            };
          } else {
            return {
              whichMenuIsOpen: null
            };
          }
        });
      };

      _this.hideMenu = function () {
        _this.setState({
          whichMenuIsOpen: null
        });
      };

      _this.handleOptionClicked = function (value) {
        if (_this.props.onChange) _this.props.onChange(value);

        _this.hideMenu();
      }; // called upon hover of a top-level menu option without children


      _this.handleOptionHover = function (value) {
        var menuState = _this.state.whichMenuIsOpen;
        var newMenuState = {
          value: value
        };
        menuState[0] = newMenuState;

        _this.setState({
          whichMenuIsOpen: [newMenuState]
        });
      }; // called upon hover of a top-level menu option with children


      _this.handleChildHeadOnHover = function (value, refHoverTarget) {
        var menuState = _this.state.whichMenuIsOpen;
        var newMenuState = {
          value: value,
          rect: refHoverTarget.getBoundingClientRect()
        };
        menuState[0] = newMenuState;

        _this.setState({
          whichMenuIsOpen: menuState
        });
      };

      _this.containerStyle = function (size) {
        switch (size) {
          case 'full':
            return styles.flexGrow;

          default:
            return null;
        }
      };

      _this.buttonWidthStyle = function (size) {
        switch (size) {
          case 'full':
            return styles.fullContainerWidth;

          case 'min':
            return null;

          default:
            return styles.defaultButtonWidth;
        }
      };

      _this.menuWidthStyle = function (size) {
        switch (size) {
          case 'full':
            return styles.fullContainerWidth;

          default:
            return styles.defaultMenuWidth;
        }
      };

      _this.childMenuWidthStyle = function (size) {
        switch (size) {
          case 'full':
            return styles.flexGrow;

          default:
            return styles.defaultMenuWidth;
        }
      };

      return _this;
    }

    _createClass(_a, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this,
            _classnames;

        var _this$props = this.props,
            className = _this$props.className,
            prefix = _this$props.prefix,
            suffix = _this$props.suffix,
            width = _this$props.width,
            children = _this$props.children,
            maxMenuHeight = _this$props.maxMenuHeight,
            value = _this$props.value,
            _this$props$omitSelec = _this$props.omitSelectedParentLabel,
            omitSelectedParentLabel = _this$props$omitSelec === void 0 ? false : _this$props$omitSelec;
        var menuStyle = maxMenuHeight ? {
          maxHeight: maxMenuHeight
        } : null;
        var selectedLabel = null;
        var whichMenuIsOpen = this.state.whichMenuIsOpen;
        var options = React.Children.map(children, function (option) {
          if (option) {
            var optionProps = option.props;
            var selected = value && isEqual(optionProps.value, value);

            if (selected) {
              selectedLabel = optionProps.selectedIcon || optionProps.label;
            }

            if (option.type.displayName === 'Select.Child') {
              if (value && value.length && isEqual(optionProps.value, value[0])) {
                var foundChildren = React.Children.toArray(optionProps.children).filter(function (c) {
                  return isEqual(c.props.value, value[1]);
                });

                if (foundChildren.length > 0) {
                  selectedLabel = omitSelectedParentLabel ? "".concat(foundChildren[0].props.label) : "".concat(option.props.label, ": ").concat(foundChildren[0].props.label);
                }
              }

              return React.createElement(SelectChild, {
                dataTest: optionProps.dataTest,
                key: "child-head-".concat(optionProps.label),
                label: optionProps.label,
                value: optionProps.value,
                onHover: _this2.handleChildHeadOnHover,
                selected: isEqual(optionProps.value, value ? value[0] : null)
              }, React.Children.map(optionProps.children, function (child, ndx) {
                return React.cloneElement(child, _objectSpread(_objectSpread({}, child.props), {}, {
                  key: "child-".concat(ndx),
                  selected: isEqual(child.props.value, value ? value[1] : null) && isEqual(optionProps.value, value[0]),
                  onClick: function onClick(v) {
                    return _this2.handleOptionClicked([optionProps.value, v]);
                  }
                }));
              }));
            } else {
              return React.cloneElement(option, {
                key: option.value,
                selected: selected,
                onClick: _this2.handleOptionClicked,
                onHover: _this2.handleOptionHover
              });
            }
          }
        });
        var childMenuOpen;

        if (whichMenuIsOpen && whichMenuIsOpen.length) {
          var childMenusOpen = options.filter(function (e) {
            return _.isEqual(whichMenuIsOpen[0].value, e.props.value);
          });
          childMenuOpen = childMenusOpen[0];
        }

        var withFooter = isSelectFooter(React.Children.toArray(children).pop());
        var buttonAriaLabel = this.props.buttonAriaLabel ? "".concat(this.props.buttonAriaLabel, ", ").concat(selectedLabel || this.props.placeholder) : '';
        return React.createElement("div", {
          className: classnames(styles.flexContainer, className)
        }, prefix, React.createElement("div", {
          className: classnames(styles.container, this.containerStyle(width)),
          ref: this.setWrapperRef
        }, React.createElement("button", {
          id: this.props.id,
          className: classnames(styles.button, buttonSize, (_classnames = {}, _defineProperty(_classnames, styles.hasPrefix, prefix), _defineProperty(_classnames, styles.hasSuffix, suffix), _classnames), this.buttonWidthStyle(width)),
          "data-test": this.props.dataTest,
          onClick: this.toggleMenu,
          disabled: this.props.disabled || this.props.loading,
          "aria-label": buttonAriaLabel
        }, this.props.loading ? React.createElement(LoadingSpinner, {
          message: this.props.loadingText
        }) : selectedLabel || this.props.placeholder, React.createElement(Icon, {
          icon: "arrow-caret-down",
          className: styles.caretIcon
        })), whichMenuIsOpen !== null && React.createElement("div", {
          style: menuStyle,
          className: classnames(styles.menu, _defineProperty({}, styles.withFooter, withFooter), this.menuWidthStyle(width)),
          "data-test": "select-menu"
        }, React.createElement("div", {
          className: styles.list
        }, options)), whichMenuIsOpen && whichMenuIsOpen.length > 0 && whichMenuIsOpen[0].rect && React.createElement("div", {
          style: {
            position: 'absolute',
            left: whichMenuIsOpen[0].rect.right - this.wrapperRef.getBoundingClientRect().left - designTokenUnit1,
            top: whichMenuIsOpen[0].rect.top - this.wrapperRef.getBoundingClientRect().top
          },
          className: classnames(styles.childmenu, styles.menu, _defineProperty({}, styles.withFooter, withFooter), this.childMenuWidthStyle(width)),
          "data-test": "select-menu"
        }, React.createElement("div", {
          className: styles.list
        }, childMenuOpen.props.children))), suffix);
      }
    }]);

    return _a;
  }(React.Component), _a.displayName = 'Select', _a;
}

var DefaultSelect = createSelect(styles.defaultButtonSize);
export var Select = Object.assign(DefaultSelect, {
  Default: DefaultSelect,
  Small: createSelect(styles.smallButtonSize)
});